import React, { useEffect, useState } from 'react';
import { Linking, Pressable, PressableProps } from 'react-native';
import useStyles from '../../../hooks/styles-hook';
import Label, { LabelType } from '../../common/Label';
import useMyAccountActions from '../../../hooks/myAccountActions-hook';

import { IconProp } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon } from '@fortawesome/react-native-fontawesome';
import { useNavigation } from '@react-navigation/native';
import type { MyAccountRouteName } from '../../../models/NavigationElements';
import { rootNavigate } from '../../../navigation/rootNavigation';

export interface MenuItemProps extends PressableProps {
  title: string;
  action?: MyAccountRouteName | null;
  bottomLine?: boolean;
  forwardProps?: any;
  labelType?: LabelType;
  icon?: IconProp;
  mirrorIcon?: boolean;
  externalLink?: string;
}

const MenuItem = (props: MenuItemProps) => {
  const styles = useStyles((section) => section.myAccount);
  const myAccountActions = useMyAccountActions();
  const navigation = useNavigation();

  const [action, setAction] = useState(props.action);
  const [externalLink, setExternalLink] = useState(props.externalLink);
  const bottomLine = props.bottomLine ?? {};

  useEffect(() => {
    setAction(props.action);
  }, [props.action]);

  useEffect(() => {
    setExternalLink(props.externalLink);
  }, [props.externalLink]);

  const handleClick = () => {
    if (action) {
      myAccountActions.setProps(props.forwardProps);
      navigation.navigate(action as never);
      return;
    } else {
      if (externalLink) {
        Linking.openURL(externalLink);
        return;
      }
    }

    // LOGOUT DISPATCH HERE
    myAccountActions.setVisibility(false);
    rootNavigate('logout');
  };

  return (
    <Pressable {...props} style={[styles.menuItem, { ...bottomLine }]} onPress={handleClick}>
      {props.icon && <FontAwesomeIcon icon={props.icon} style={[styles.menuItem.icon, props.mirrorIcon ? styles.menuItem.icon.mirror : {}]} />}
      <Label variant={props.labelType ?? LabelType.myAccountLink}>{props.title}</Label>
    </Pressable>
  );
};

export default MenuItem;
